 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>执行控制器</h4>
          <el-button type="primary" class="adduser" @click="handleAdd"
            >添加</el-button
          >
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="设备类型：">
            <el-select
              v-model="searchForm.deviceType"
              clearable
              placeholder="请选择设备类型"
              @change="handleSearch"
            >
              <el-option label="侧窗" value="1"></el-option>
              <el-option label="风机" value="2"></el-option>
              <el-option label="湿帘" value="3"></el-option>
              <el-option label="空调" value="4"></el-option>
              <el-option label="水肥机" value="5"></el-option>
              <el-option label="农业补光灯" value="6"></el-option>
              <el-option label="鲜花柜温控中心" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启用状态：">
            <el-select
              v-model="searchForm.status"
              clearable
              placeholder="请选择启用状态"
              @change="handleSearch"
            >
              <el-option label="启动" value="0"></el-option>
              <el-option label="禁用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="设备类型">
              <template slot-scope="scope">
                <p v-if="scope.row.deviceType == 1">侧窗</p>
                <p v-if="scope.row.deviceType == 2">风机</p>
                <p v-if="scope.row.deviceType == 3">湿帘</p>
                <p v-if="scope.row.deviceType == 4">空调</p>
                <p v-if="scope.row.deviceType == 5">水肥机</p>
                <p v-if="scope.row.deviceType == 6">农业补光灯</p>
                <p v-if="scope.row.deviceType == 7">鲜花柜温控中心</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.switchName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.switchAttrName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="开关开度">
              <template slot-scope="scope">
                <p>{{ scope.row.opening }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="启用状态">
              <template slot-scope="scope">
                <p v-if="scope.row.status == 0">启用</p>
                <p v-if="scope.row.status == 1">禁用</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handlePart(scope.row)"
                  type="text"
                  size="small"
                  v-if="controlType == 1"
                  >局部控制</el-button
                >
                <el-button
                  @click="handleStatus(scope.row)"
                  type="text"
                  size="small"
                  v-if="scope.row.status == 1"
                  >启用</el-button
                >
                <el-button
                  @click="handleStatus(scope.row)"
                  type="text"
                  size="small"
                  v-if="scope.row.status == 0"
                  >禁用</el-button
                >
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          :title="addEditTitle"
          :visible.sync="addEditIsDialog"
          :before-close="handleCancel"
          width="600px"
          center
          style="z-index: 10000"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备类型：" prop="deviceType">
                  <el-select
                    v-model="ruleForm.deviceType"
                    placeholder="请选择设备类型"
                    clearable
                  >
                    <el-option label="侧窗" value="1"></el-option>
                    <el-option label="风机" value="2"></el-option>
                    <el-option label="湿帘" value="3"></el-option>
                    <el-option label="空调" value="4"></el-option>
                    <el-option label="水肥机" value="5"></el-option>
                    <el-option label="农业补光灯" value="6"></el-option>
                    <el-option label="鲜花柜温控中心" value="7"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备属性：" prop="deviceAttributeId">
                  <el-select
                    v-model="ruleForm.deviceAttributeId"
                    placeholder="请选择设备属性"
                    clearable
                    @change="deviceAttributeChange"
                  >
                    <el-option
                      v-for="item in deviceAttributeArray"
                      :key="item.deviceId + ',' + item.attributeId"
                      :label="item.deviceName + '_' + item.attributeName"
                      :value="item.deviceId + ',' + item.attributeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="设备名称：" prop="switchId">
                  <el-select
                    v-model="ruleForm.switchId"
                    placeholder="请选择设备名称"
                    clearable
                    @change="deviceChange"
                  >
                    <el-option
                      v-for="item in deviceArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="属性名称：" prop="switchAttrId">
                  <el-select
                    v-model="ruleForm.switchAttrId"
                    placeholder="请选择属性名称"
                    clearable
                    @change="attributeChange"
                  >
                    <el-option
                      v-for="item in attributeArray"
                      :key="item.id"
                      :label="item.cname"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="24">
                <el-form-item label="开关开度：" prop="opening">
                  <el-input-number
                    v-model="ruleForm.opening"
                    placeholder="请输入开关开度"
                    :min="0"
                    :max="100"
                    :precision="0"
                    :step="1"
                    size="small"
                    :disabled="!isOpening"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
 <script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        paramId: "",
        deviceType: "",
        status: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        paramId: "",
        deviceType: "",
        switchId: "",
        switchAttrId: "",
        opening: "",
        deviceAttributeId: "",
      },
      rules: {
        // 添加编辑表单规则
        deviceType: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        deviceAttributeId: [
          {
            required: true,
            message: "请选择设备属性",
            trigger: "change",
          },
        ],
        // switchId: [
        //   {
        //     required: true,
        //     message: "请选择设备名称",
        //     trigger: "change",
        //   },
        // ],
        // switchAttrId: [
        //   {
        //     required: true,
        //     message: "请选择属性名称",
        //     trigger: "change",
        //   },
        // ],
        opening: [
          {
            required: true,
            message: "请输入开关开度",
            trigger: "blur",
          },
        ],
      },
      paramId: "", // 生长模型环境参数ID
      deviceArray: [], // 设备数组
      attributeArray: [], // 属性数组
      addEditTitle: "添加执行控制器", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      isOpening: false, // 是否可以填写开度，仅仅模拟开关可以填写，其它默认0
      controlType: "", // 控制类型（0整体控制，1局部控制，局部控制时，需要添加下级的局部控制设备）
      deviceAttributeArray: [], // 设备属性数组
    };
  },
  created() {
    this.searchForm.paramId = this.$route.query.paramId;
    this.ruleForm.paramId = this.$route.query.paramId;
    this.paramId = this.$route.query.paramId;
    this.controlType = this.$route.query.controlType;

    // 获取大棚设备标签列表
    this.getControlDevices();

    // 查询
    this.getList();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        paramId: this.paramId,
        deviceType: "",
        status: "",
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthModelDeviceSwitchList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除时需要检测下该开关是否启用，如果启用需要提醒
          this.$api.growthModel.judge({ id: row.id }).then((res) => {
            if (res.code == 200) {
              if (res.data.status == 1) {
                this.$confirm(
                  "所在生长模型正在运行中，是否继续删除？",
                  "提示",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                )
                  .then(() => {
                    // 删除
                    this.delGrowthModelDeviceSwitch(row);
                  })
                  .catch(() => {
                    this.$message.info("已取消删除");
                  });
              } else {
                // 删除
                this.delGrowthModelDeviceSwitch(row);
              }
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 删除
    delGrowthModelDeviceSwitch(row) {
      this.$api.growthModel.delGrowthModelDeviceSwitch(row.id).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getList();
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑执行控制器";
      this.ruleForm.id = row.id;
      this.ruleForm.modelId = this.paramId;

      // 获取详情
      this.$api.growthModel
        .getGrowthModelDeviceSwitch({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            res.data.deviceType =
              res.data.deviceType != undefined
                ? res.data.deviceType.toString()
                : "";
            res.data.deviceAttributeId =
              res.data.switchId + "," + res.data.switchAttrId;
            this.ruleForm = res.data;

            // 获取属性列表
            //this.getAttributeList();
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加执行控制器";
      this.ruleForm.id = "";
      this.ruleForm.modelId = this.paramId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthModelDeviceSwitch(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 获取设备列表
    getDeviceList() {
      this.$api.device
        .getAllDeviceSwitchs({ groupId: this.$route.query.groupId })
        .then((res) => {
          if (res.code == 200) {
            this.deviceArray = res.data;
          }
        });
    },
    // 设备下拉切换
    deviceChange() {
      this.ruleForm.switchAttrId = "";
      this.attributeArray = [];
      this.isOpening = false;
      this.ruleForm.opening = 0;

      // 获取属性列表
      this.getAttributeList();
    },
    // 获取属性列表
    getAttributeList() {
      this.$api.device
        .getAttributesBySwtichId(this.ruleForm.switchId)
        .then((res) => {
          if (res.code == 200) {
            this.attributeArray = res.data;

            // 属性下拉切换
            this.attributeChange();
          }
        });
    },
    // 属性下拉切换
    attributeChange() {
      var switchType = -1;

      if (this.ruleForm.switchAttrId) {
        this.attributeArray.forEach((val) => {
          if ((val.id = this.ruleForm.switchAttrId)) {
            switchType = val.switchType;
          }
        });
      }

      if (switchType == 1 || switchType == 4) {
        this.isOpening = true;
      } else {
        this.isOpening = false;
        this.ruleForm.opening = 0;
      }
    },
    // 启用禁用
    handleStatus(row) {
      // 启用禁用时需要检测下该开关是否启用，如果启用需要提醒
      this.$api.growthModel.judge({ id: row.id }).then((res) => {
        if (res.code == 200) {
          if (res.data.status == 1) {
            this.$confirm(
              "所在生长模型正在运行中，是否继续" +
                (row.status == 0 ? "禁用" : "启用") +
                "？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                // 启用禁用
                this.openOrCloseGrowthModelDeviceSwitch(row);
              })
              .catch(() => {
                this.$message.info(
                  "已取消" + (row.status == 0 ? "禁用" : "启用")
                );
              });
          } else {
            // 启用禁用
            this.openOrCloseGrowthModelDeviceSwitch(row);
          }
        }
      });
    },
    // 启用禁用
    openOrCloseGrowthModelDeviceSwitch(row) {
      this.$api.growthModel
        .openOrCloseGrowthModelDeviceSwitch({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            this.getList();
          }
        });
    },
    // 局部控制设备
    handlePart(row) {
      this.$router.push({
        name: `growthModelPartControlDeviceManagement`,
        query: {
          deviceSwitchId: row.id,
          deviceSwitchName:
            this.$route.query.paramName +
            "_环境控制设备（" +
            row.switchName +
            "_" +
            row.switchAttrName +
            "）",
          paramId: this.$route.query.paramId,
          paramType: this.$route.query.paramType,
          paramName: this.$route.query.paramName,
          paramUnit: this.$route.query.paramUnit,
          evnId: this.$route.query.evnId,
          evnName: this.$route.query.evnName,
          groupId: this.$route.query.groupId,
          controlType: this.$route.query.controlType,
        },
      });
    },
    // 获取大棚设备标签列表
    getControlDevices() {
      this.$api.growthModel
        .getControlDevices({
          type: 3,
          deviceSign: this.$route.query.paramType,
          groupId: this.$route.query.groupId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceAttributeArray = res.data;
          }
        });
    },
    // 设备属性下拉切换
    deviceAttributeChange() {
      if (this.ruleForm.deviceAttributeId) {
        let arr = this.ruleForm.deviceAttributeId.split(",");
        this.ruleForm.switchId = arr[0];
        this.ruleForm.switchAttrId = arr[1];
      } else {
        this.ruleForm.switchId = "";
        this.ruleForm.switchAttrId = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>